(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prv-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function wire(header) {
      if (header.__prvReady) return;
      header.__prvReady = true;

      var burger = header.querySelector('[data-prv-burger]');
      var drawer = header.querySelector('[data-prv-drawer]');
      if (!burger || !drawer) return;

      function setOpen(open) {
        drawer.hidden = !open;
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.documentElement.style.overflow = open ? 'hidden' : '';
      }

      burger.addEventListener('click', function () {
        setOpen(burger.getAttribute('aria-expanded') !== 'true');
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
          setOpen(false);
          burger.focus();
        }
      });

      window.addEventListener('resize', function () {
        if (window.innerWidth >= 1100 && burger.getAttribute('aria-expanded') === 'true') {
          setOpen(false);
        }
      });

      reveal(header, function () {
        return burger.getAttribute('aria-expanded') === 'true';
      });
    }

    /* ---- Tuck on scroll down, drop back on scroll up -------------------- */
    function reveal(header, drawerIsOpen) {
      if (!header.hasAttribute('data-prv-reveal')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var GRACE = 140; // never tuck this close to the top of the page
      var DEAD = 5;    // ignore scroll jitter smaller than this

      // The wrapper is what sticks, so the wrapper is what has to move.
      var host = header.closest('#header-group') || header;

      // The declared height from the section settings, NOT a DOM measurement.
      // offsetHeight at init can be read before the section stylesheet applies,
      // and until it does the logo renders at its intrinsic size, so the header
      // measures hundreds of pixels tall. That number was then written into
      // --header-height, and The Archive's filter bar sticks at
      // top: var(--header-height) — which is how it ended up parked in the
      // middle of the viewport. Reproduced at 1280px with a 1200px logo. A
      // declared value cannot be measured at the wrong moment.
      var declared = parseInt(header.getAttribute('data-prv-height'), 10);
      var baseHeight = declared > 0 ? declared : header.offsetHeight;

      var pendingY = 0;
      var tucked = false;
      var ticking = false;

      // Seed from wherever the page already is. Priming off the first scroll
      // event would swallow the first gesture, and starting at 0 would read a
      // restored scroll position (back button) as a downward scroll.
      function initialY() {
        var el = header.parentElement;
        while (el) {
          if (el.scrollTop > 0) return el.scrollTop;
          el = el.parentElement;
        }
        return window.scrollY || document.documentElement.scrollTop || 0;
      }

      var lastY = initialY();

      // Horizon does not scroll the window on desktop. At >=990px it makes
      // .page-wrapper the scroll container (overflow-y:auto; height:100dvh) and
      // window.scrollY stays 0 forever. The listener is capture-phase on
      // document and reads whichever element actually fired, so it works under
      // both models without hard-coding the theme's class name.
      function isPageScroller(t) {
        if (!t || t === document || t === window) return true;
        if (t === document.documentElement || t === document.body) return true;
        if (t.nodeType !== 1) return false;
        // Excludes small inner scrollers such as the archive's category strip.
        return t.scrollHeight > t.clientHeight && t.clientHeight >= window.innerHeight * 0.75;
      }

      function yOf(t) {
        if (!t || t === document || t === window || t === document.documentElement || t === document.body) {
          return window.scrollY || document.documentElement.scrollTop || 0;
        }
        return t.scrollTop;
      }

      function setTucked(next) {
        if (next === tucked) return;
        tucked = next;
        host.classList.toggle('is-tucked', next);
        document.documentElement.style.setProperty(
          '--header-height',
          next ? '0px' : baseHeight + 'px'
        );
      }

      function measure() {
        ticking = false;
        var y = Math.max(0, pendingY);
        var dy = y - lastY;

        if (drawerIsOpen() || y <= GRACE) {
          setTucked(false);
        } else if (dy > DEAD) {
          setTucked(true);
        } else if (dy < -DEAD) {
          setTucked(false);
        }

        if (Math.abs(dy) > DEAD) lastY = y;
      }

      document.addEventListener(
        'scroll',
        function (e) {
          if (!isPageScroller(e.target)) return;
          pendingY = yOf(e.target);
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(measure);
        },
        { capture: true, passive: true }
      );

      header.addEventListener('focusin', function () {
        setTucked(false);
      });

      // No re-measuring on resize: the declared height is authoritative, and
      // re-reading offsetHeight is what let a bad value in to begin with.
    }

    function boot() {
      document.querySelectorAll('[data-prv-header]').forEach(wire);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
